import type { Ereignis, EreignisCreate, EreignisUpdate, EreignisStatus, Massnahme } from "@iso27001/shared";
import { apiFetch } from "./client.js";
import type { AuditEntry } from "../components/AuditHistoryModal.js";

interface ListResp<T> { items: T[]; total: number; page: number; pageSize: number; }

export const ereignisseLinks = {
  listMassnahmen: (id: number) => apiFetch<{ items: Massnahme[] }>(`/api/ereignisse/${id}/massnahmen`),
};

export const ereignisseApi = {
  list: (params: { q?: string; status?: EreignisStatus; page?: number; pageSize?: number } = {}): Promise<ListResp<Ereignis>> => {
    const qs = new URLSearchParams();
    if (params.q) qs.set("q", params.q);
    if (params.status) qs.set("status", params.status);
    if (params.page) qs.set("page", String(params.page));
    if (params.pageSize) qs.set("pageSize", String(params.pageSize));
    const url = `/api/ereignisse${qs.toString() ? `?${qs}` : ""}`;
    return apiFetch<ListResp<Ereignis>>(url);
  },
  get: (id: number): Promise<Ereignis> => apiFetch<Ereignis>(`/api/ereignisse/${id}`),
  create: (body: EreignisCreate): Promise<Ereignis> =>
    apiFetch<Ereignis>("/api/ereignisse", { method: "POST", body: JSON.stringify(body) }),
  update: (id: number, body: EreignisUpdate): Promise<Ereignis> =>
    apiFetch<Ereignis>(`/api/ereignisse/${id}`, { method: "PATCH", body: JSON.stringify(body) }),
  remove: (id: number): Promise<null> =>
    apiFetch<null>(`/api/ereignisse/${id}`, { method: "DELETE" }),
  audit: (id: number): Promise<{ items: AuditEntry[] }> =>
    apiFetch<{ items: AuditEntry[] }>(`/api/ereignisse/${id}/audit`),
};
